import { render, staticRenderFns } from "./DashboardliveReports.vue?vue&type=template&id=67c9c050&"
import script from "./DashboardliveReports.vue?vue&type=script&lang=js&"
export * from "./DashboardliveReports.vue?vue&type=script&lang=js&"
import style0 from "./DashboardliveReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports